import React from "react";
import TopPostsFeed from "@/components/TopPostsFeed";

export default function TopPostsSection() {
  // Phase 84.30 — was static demo data. Now pulls real top posts from every
  // connected channel via /api/marketing/top-posts.
  return <TopPostsFeed limit={18} />;
}
